
import Loading from 'vux/src/components/loading/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XNumber from 'vux/src/components/x-number/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'

import { getInvestorPersonal, getInvestorOtherAuth } from 'api/investor'
import { formatOldCatType } from 'components/InvestorInfo/common/investorConfig'
import OneLook from './OneLook.vue'
export default {
components: {
Loading,
Group,
XHeader,
XInput,
Selector,
XNumber,
Datetime,
XButton,
OneLook,
CheckIcon,
XSwitch
},
data () {
return {
demo01: '',
list: ['广东', '广西'],
isEdit: false,  // 是否修改
loading: true,
hasResp: false,
baseInfo: {
type: 1, // 1新增 0 查看
isNormal: 1,
invenstemType: 'SPECIFIC_PERSONAL_ORDINARY',
isShowBtn: false,
userId: 1755,
managerId: 1673,
invenstemUserId: 2023,
stepCurrent: 0,
stepTotal: 0,
au: 'eUJpWXhmNTJZMWtya0NDNDF5QjlwTThJcnFPWTdzMUhxdEc0dktXdHl3ZUtGSW4vZmVSaERDS0N4aWJreWl1Tw==',
orgType: 'fund'
},
isYJ: false,
data: {
userName: '',
userSex: '',
userAge: '',
documentsType: '身份证',
idCardNo: '',
userCountry: '中国',
userOccupation: '党政机关、事业单位',
userPosition: '',
userLandline: '',
userMobile: '',
documentsValidity: '',
zip: '',
userEmail: '',
userAddress: ''
},
isIdCard: function (value) {
return {
valid: /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[xX])$/.test(value),
msg: '身份证号码格式不正确'
}
},
isPhone: function (value) {
return {
valid: /\d{1,20}/.test(value),
msg: '号码格式不正确'
}
},
valid: {
userName: false,
userAge: false,
documentsType: false,
idCardNo: false,
userCountry: false,
userOccupation: false,
userSex: false,
userPosition: false,
userLandline: false,
userMobile: false,
zip: false,
userEmail: false,
userAddress: false
}
}
},
created () {
this.$vux.loading.show({text: '加载中'})
setTimeout(() => {
this.$bridge.registerHandler('getUpdate', this.$_personal_update)
this.$_personal_init()
}, this.initTime)
},
watch: {
isYJ: function (val, oldVal) {
if (val) {
console.log('2222')
this.data.documentsValidity = '永久有效'
} else {
this.data.documentsValidity = ''
}
}
},
methods: {

$_personal_update () {
this.isEdit = true
this.baseInfo.type = 1
},

$_personal_init () {
let _this = this
console.log(_this.isDev, _this.baseInfo.type)

if (_this.isDev) {
_this.loading = false
_this.$vux.loading.hide()
if (_this.baseInfo.type === 0) {
_this.$_personal_info(this.baseInfo.userId, this.baseInfo.invenstemUserId, _this.baseInfo.au)
}
} else {
let info = `新增/查看投资者信息,
参数
type（1 新增, 0 查看),
isNormal(1是 0 否，string类型),
userId(用户Id),
invenstemUserId(理财师拥有的投资者ID,新增不传),
invenstemType(投资者特定对象认证类型),
au`
_this.$bridge.callHandler('getUserInfo', {message: info}, function (data) {
_this.loading = false
_this.$vux.loading.hide()
const res = JSON.parse(data)
console.log('psersonal', res)
if (res.type && res.isNormal && res.userId && res.invenstemType && res.au) {
_this.baseInfo.isShowBtn = parseInt(res.isShowBtn || 0)
_this.baseInfo.type = parseInt(res.type)
_this.baseInfo.isNormal = parseInt(res.isNormal)
_this.baseInfo.userId = res.userId
_this.baseInfo.invenstemType = res.invenstemType
_this.baseInfo.invenstemUserId = res.invenstemUserId
_this.baseInfo.au = res.au
_this.baseInfo.stepCurrent = parseInt(res.stepCurrent)
_this.baseInfo.stepTotal = parseInt(res.stepTotal)
_this.baseInfo.orgType = res.orgType
console.log(res.stepCurrent, res.stepTotal, _this.baseInfo)
if (parseInt(res.type) === 0) {
_this.$_personal_info(res.userId, res.invenstemUserId, res.globalVersion, res.au)
}
} else {
_this.$vux.toast.show({
type: 'warn',
text: '信息获取失败'
})
}
})
}
},
idcardChange (val) {
if (this.baseInfo.type === 1) {
if (val && val.length === 18) {
let year = parseInt(val.substring(6, 10))
let Year = new Date().getFullYear()
this.data.userAge = Year - year
let sex = parseInt(val.substr(16, 1))
this.data.userSex = sex % 2 === 0 ? '女' : '男'
}
}
},

$_personal_info (userId, invenstemUserId, globalVersion, au) {
getInvestorPersonal({userId: userId, invenstemUserId: invenstemUserId, globalVersion: globalVersion}, au).then((res) => {
if (res.code === 0) {
const resBean = res.data.bean
console.log('person-one:', resBean)
this.data = {
userName: resBean.userName,
userSex: resBean.userSex,
userAge: resBean.userAge,
documentsType: formatOldCatType(resBean.documentsType || '身份证'),
idCardNo: resBean.idCardNo,
userCountry: resBean.userCountry,
userOccupation: resBean.userOccupation,
userPosition: resBean.userPosition,
userLandline: resBean.userLandline,
userMobile: resBean.userMobile,
zip: resBean.zip,
documentsValidity: resBean.documentsValidity,
userEmail: resBean.userEmail,
userAddress: resBean.userAddress,
oldInfo: JSON.stringify(resBean)
}
this.hasResp = true
} else {
this.$vux.toast.show({
type: 'warn',
text: res.msg
})
}
})
},
$_personal_auth () {
if (this.baseInfo.type === 0) {
this.$_personal_next()
} else {
for (var item in this.valid) {
if (this.data[item] === '') {
this.$vux.toast.show({type: 'warn', text: this.$refs[item].title + '为空或输入不合规范'})
return
}
}
this.$_handle_auth()
}
},

$_handle_auth () {
this.$vux.loading.show({text: '加载中'})
getInvestorOtherAuth({
userId: this.baseInfo.userId,
invenstemType: this.baseInfo.invenstemType,
invenstemUserId: this.baseInfo.invenstemUserId,
name: this.data.userName,
idCard: this.data.idCardNo
}, this.baseInfo.au).then((res) => {
this.$vux.loading.hide()
if (res.code === 0) {
this.$_personal_next()
} else {
this.$vux.alert.show({
title: '提示',
content: res.msg
})
}
})
},

$_personal_next () {
this.data.type = this.baseInfo.type
this.data.isNormal = this.baseInfo.isNormal
this.$router.push({path: '/investor/personal/question', query: this.data})
}
}
}



// WEBPACK FOOTER //
// ./src/components/InvestorInfo/Personal/One.vue